import { useEffect } from "react";
import { Hero } from "@/pages/home/Hero";
import { Marquee } from "@/pages/home/Marquee";
import { Stats } from "@/pages/home/Stats";
import { WhyChoose } from "@/pages/home/WhyChoose";
import { ServicesGrid } from "@/components/ServicesGrid";
import { PortfolioGrid } from "@/components/PortfolioGrid";
import { ProcessSteps } from "@/components/ProcessSteps";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { ContactSection } from "@/components/ContactSection";
import { BUSINESS } from "@/data/site";

export default function Home() {
  useEffect(() => {
    document.title = `${BUSINESS.name} — ${BUSINESS.tagline}`;
  }, []);
  return (
    <>
      <Hero />
      <Marquee />
      <Stats />
      <WhyChoose />
      <ServicesGrid />
      <PortfolioGrid />
      <ProcessSteps />
      <Testimonials />
      <Faq />
      <FinalCta />
      <ContactSection />
    </>
  );
}
